// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { z } from 'zod';

export const assetInventoryStatusSchema = z.enum([
  'in_inventory',
  'not_in_inventory',
]);

export type AssetInventoryStatus = z.infer<typeof assetInventoryStatusSchema>;
